import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 43.2 43.2"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M43.2 21.6 21.6 43.1 0 21.6 21.6 0l21.6 21.6z",
      style: {"fill":"#fff"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M43.2 21.6 36 14.4l-1.6-1.6V16l-1.6 1.6v-6.4l-1.6-1.6v9.6l-1.6 1.6V8l-.8-.8L21.6 0l-7.2 7.2-.8.8v12.8L12 19.2V9.6l-1.6 1.6v6.4L8.8 16v-3.2l-1.6 1.6L0 21.6l7.2 7.2 1.6 1.6v-3.2l1.6-1.6V32l1.6 1.6V24l1.6-1.6v12.8l.8.8 7.2 7.2 7.2-7.2.8-.8V22.3l1.6 1.6v9.6l1.6-1.6v-6.4l1.6 1.6v3.2l1.6-1.6 7.2-7.1Zm-21.6-7.2Zm6.4 7.9v12.8l-1.6-1.6v-9.6l-1.6 1.6v6.4l-1.6-1.6v-3.2l-1.6 1.6-1.6-1.6v3.2l-1.6 1.6v-6.4l-1.6-1.6v9.6l-1.6 1.6V22.3l-.8-.8.8-.8V8l1.6 1.6v9.6l1.6-1.6v-6.4l1.6 1.6V16l1.6-1.6 1.6 1.6v-3.2l1.6-1.6v6.4l1.6 1.6V9.6L28 8v12.8l.8.8-.8.7Z",
      style: {"fill":"#e10e49"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "V7-logo"}) } }